import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from '../../../components/Reusable/WithRouter';
import CustomerService from '../../../services/Customer.service';
import CustomerAction from "../../../redux/actions/Customer.action";
import CustomerHeader from "../../../components/layout/CustomerHeader"
import CallCenterHeader from "../../../components/layout/CallCenter/CallCenterHeader"
import CustomerFooter from "../../../components/layout/CustomerFooter";
import Common from '../../../hoc/Common.hoc';
import CountryService from '../../../services/Country.service';
import Dropdown from '../../../components/SearchableDropdown/Dropdown.component';
import CallCenterAction from '../../../redux/actions/CallCenter.action';
class Registration extends Component {
    constructor(props) {
        super(props)

        this.state = {
            registration: this.customerRegModel(),
            doctorName: "",
            selectedFile: null,
            fileUploadError: '',
            imagename: '',
            color: 'red',
            age: null,
            isValidAge: false,
            countries: [],
            states: [],
            towns: [],
            showTowns: false,
            prescription: null,
            isLoading: false,
            isChecked: false,
            previousCustomerDetails: null
        }
        this.fileInputRef = React.createRef();
    }

    static getDerivedStateFromProps(props, state) {
        console.log(props, "kjdshkjshkd");
        return {
            prescription: props.CallCenterReducer.prescription || null
        }
    }

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({ selectedFile: file, fileUploadError: '', imagename: '' }, () => {
                this.handleUpload()
            });
        }
    };

    handleButtonClick = () => {

        // Programmatically trigger the file input click event
        this.fileInputRef.current.click();
    };

    handleUpload = () => {
        console.log(this.state.isLoading, "loading status");

        const MaxFileSize = 10 * 1024 * 1024; // 10MB in bytes
        // Handle the file upload logic here
        const { selectedFile } = this.state;

        if (selectedFile) {
            this.setState({ isLoading: true });
            const fileType = selectedFile.type;
            const fileSizeMB = selectedFile.size / (1024 * 1024);
            if (fileType !== 'image/jpeg' && fileType !== 'image/png' && fileType !== 'application/pdf') {

                this.setState({ isLoading: false });
                this.setState({ fileUploadError: 'Only JPG, PNG, and PDF files are allowed.', color: "red" });

                return;
            }
            else if (fileSizeMB > 10) {
                this.setState({ isLoading: false });
                this.setState({ fileUploadError: 'File size must be less than 10MB.', color: "red" });

                return;
            }
            else {
                let payload = new FormData()
                payload.append("customer_id", this.props.CallCenterReducer.callcentercustomer._id || null)
                payload.append("doctor_id", this.props.CallCenterReducer.callcentercustomer.prescribedDoctor._id || null)
                payload.append("prescription", selectedFile)

                //console.log('File to upload:', selectedFile, this.props.CallCenterReducer.customer, payload);
                CustomerService.uploadPrescription(payload).then(data => {
                    console.log(data.data.data.filepath, "data !!!!!!!!!!!!file pathh");
                    this.getPrescription()
                    this.setState({ isLoading: false });
                    this.setState({ fileUploadError: 'Prescription uploaded', color: "green", imagename: data.data.data.filepath });


                }).catch(err => {
                    this.setState({ isLoading: false });
                    console.log(err, "err")
                })
            }
        } else {
            this.setState({ fileUploadError: 'Please select a file first.' });
        }
    };

    customerRegModel = (data = { address: {} }) => {
        if (data.address == null) {
            data.address = {};
        }


        const obj = {
            name: data.name ? data.name : "",
            address: {
                country: data.address.country ? data.address.country : "",
                addressLine1: data.address.addressLine1 ? data.address.addressLine1 : "",
                addressLine2: data.address.addressLine2 ? data.address.addressLine2 : "",
                town: data.address.town ? data.address.town : "",
                state: data.address.state ? data.address.state : "",
                pin: data.address.pin ? data.address.pin : "",
            },
            age: data.age ? data.age : "",
            email: data.email ? data.email : "",
            mobileno: data.mobileno ? data.mobileno : "",
            gender: data.gender ? data.gender : ""
        }
        return { ...obj }
    }

    componentDidMount() {
        CountryService.getCountries().then(data => {
            //console.log(data, "countries")
            if (data.success) {
                this.setState({ countries: data.countries })
            }
        })
        const customer = this.props.CallCenterReducer.callcentercustomer;

        this.setState({ previousCustomerDetails: customer })

        console.log(customer, "customer1233")
        //console.log(this.customerRegModel(customer), customer, 89347298379823474)
        this.getPrescription()
        this.setState({
            registration: customer ? this.customerRegModel(customer) : this.customerRegModel(),
            doctorName: customer.prescribedDoctor ? customer.prescribedDoctor.name : ""
        }, async () => {
            let registration = await this.state.registration
            registration["address"]["country"] = "India"
            await this.setState({ registration })
            // let country = await this.state.registration.address.country || null
            // console.log(country);
            // if (country) {
            // let countryObj = this.state.countries.find(i => i.name === "India")
            // alert(JSON.stringify(countryObj))
            setTimeout(() => {
                this.populateStates("IN")
                // this.populateStates(countryObj.isoCode)
            }, 500);
            // }
        })
    }


    getPrescription = () => {
        const customer = this.props.CallCenterReducer.callcentercustomer;
        let customer_id = customer._id || null
        let doctor_id = customer.prescribedDoctor._id || null
        //console.log(customer_id, doctor_id, customer, 4444444);
        if (customer_id && doctor_id) {
            CustomerService.getPrescription({ customer_id, doctor_id }).then(data => {
                //console.log(data, "getPrescription");
                if (data.success) {
                    let prescription = this.state.prescription
                    if (prescription) {
                        this.setState({ fileUploadError: 'Prescription uploaded', color: "green", imagename: prescription.filepath || "", selectedFile: true });
                    }
                }
            })
        }
    }

    changeVal = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        const registration = { ...this.state.registration };
        registration[name] = value;
        this.setState({ registration: registration });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.CallCenterReducer.callcentercustomer !== this.props.CallCenterReducer.callcentercustomer) {
            const customer = this.props.CallCenterReducer.callcentercustomer;
            this.setState({
                registration: customer ? this.customerRegModel(customer) : this.customerRegModel(),
                doctorName: customer.prescribedDoctor ? customer.prescribedDoctor.name : ""
            })
        }
    }


    changeAddr = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        const address = { ...this.state.registration.address };
        address[name] = value;
        this.setState({ registration: { ...this.state.registration, address: { ...address } } });
    }

    next = () => {

        const addressLine1 = this.state.registration.address.addressLine1;
        const country = this.state.registration.address.country == "India" ? "India" : "India";
        const state = this.state.registration.address.state;
        const pin = this.state.registration.address.pin;
        const town = this.state.registration.address.town;
        const name = this.state.registration.name;
        const age = this.state.registration.age;
        const gender = this.state.registration.gender;
        const email = this.state.registration.email;
        const mobileno = this.state.registration.mobileno;
        //console.log('dvdfbbgnghmnhjgfkl>>>>>>>>>>>', this.state)


        const customerPrevData = this.props.CallCenterReducer.callcentercustomer;



        console.log(pin.toString().length, "pinnnn");
        if (email && email !== "") {
            if (!this.props.hoc.verifyEmail(email)) {
                this.props.hoc.customAlert('Please provide a valid email.', false)
                return false
            }
        }
        if (!addressLine1 && addressLine1 == "") {
            this.props.hoc.customAlert('Address Line 1 is required.', false)
            return false
        } else if (!mobileno && mobileno == "") {
            this.props.hoc.customAlert('Mobileno is required.', false)
            return false
        }
        else if (!country && country == "") {
            this.props.hoc.customAlert('Country is required.', false)
            return false
        }
        else if (!state && state == "") {
            this.props.hoc.customAlert('State is required.', false)
            return false
        }
        else if (!pin && pin == "") {
            this.props.hoc.customAlert('Pincode is required.', false)
            return false
        }
        else if (pin && pin.toString().length < 6) {
            this.props.hoc.customAlert('Pincode must be 6 digits.', false)
            return false
        }
        else if (!town && town == "") {
            this.props.hoc.customAlert('Town is required.', false)
            return false
        }
        else if (!name && name == "") {
            this.props.hoc.customAlert('Name is required.', false)
            return false
        }
        else if (!age && age == "") {
            this.props.hoc.customAlert('Age is required.', false)
            return false
        }
        else if (!gender && gender == "") {
            this.props.hoc.customAlert('Gender is required.', false)
            return false
        }
        // else if (age < 18) this.props.hoc.customAlert("Age must be greater than or equal to 18", false)
        // else if (!this.state.selectedFile) this.props.hoc.customAlert("Please upload prescription", false)
        // else if (this.props.CallCenterReducer.consentValue == false || this.props.CallCenterReducer.consentValue == null) {

        //     this.props.hoc.customAlert('Please check consent checkbox.', false)
        //     return false
        // }
        else {

            let oldValuKey = [];
            //console.log('test 135465874>>>>>>>>>>>>>>>>>>>>>')
            const { registration, previousCustomerDetails } = this.state;
            let current_data = Object.entries(registration)
            console.log(current_data, 'current_data', current_data.length);
            for (let i = 0; i < current_data.length; i++) {
                console.log(current_data[i], current_data[i][0], current_data[i][1], 9999999);
                if (current_data[i][1] != previousCustomerDetails[current_data[i][0]]) {
                    if (current_data[i][0] != "address") {
                        oldValuKey.push({ [current_data[i][0]]: previousCustomerDetails[current_data[i][0]] });
                    }

                    console.log("ok", i, current_data[i][1]);
                    if (current_data[i][0] === "address") {
                        let address_data = Object.entries(registration.address);

                        for (let j = 0; j < address_data.length; j++) {

                            if (address_data[j][1] != previousCustomerDetails[current_data[i][0]][address_data[j][0]]) {
                                oldValuKey.push({ [address_data[j][0]]: previousCustomerDetails[current_data[i][0]][address_data[j][0]] });
                                console.log(address_data[j][0], previousCustomerDetails[current_data[i][0]][address_data[j][0]], "address_data_key");
                            }

                        }

                        console.log(address_data, "address_data");
                    }
                }
            }


            console.log(oldValuKey, "oldValuKey")

            // return
            // registration.address.country = "India"
            const id = this.props.CallCenterReducer.callcentercustomer._id;
            const doctor_id = this.props.CallCenterReducer.callcentercustomer.prescribedDoctor[0];

            let detailsCustomer = {
                customer_id: id,
                doctor_id: doctor_id ? doctor_id : null,
            };
            let _registration = { ...registration, doctor_id: doctor_id || null }
            //console.log(_registration, id, prescription, 8989);
            // return
            const callcenter_id = this.props.CallCenterReducer.callcenterdetails._id;

            // console.log(callcenter_id,"callcenter_id");

            // return
            // console.log(callcenter_id,"callcenter_id");
            // return
            CustomerService.updateCustomer({ registration: _registration, id, oldValuKey, callcenter_id }).then(async res => {
                if (res && res.data && res.data.success && res.data.data) {

                    console.log(customerPrevData, "customer previous data");



                    let customer = res.data.data.customer
                    if (customer["prescribedDoctor"] && Array.isArray(customer["prescribedDoctor"])) {
                        customer["prescribedDoctor"] = customer["prescribedDoctor"].length ? customer["prescribedDoctor"][0] : null
                    }
                    //console.log(customer, 87870987)
                    // OtherService.getCustomerOut().then(res => {
                    //     // //console.log(res, 7878);

                    //     if (res && res.data && res.data.success) {
                    //         //console.log(res, 123456);
                    //     }

                    // }).catch(err => {
                    //     //console.log(err)
                    // })

                    // OtherService.getCustomerDetailsOut(detailsCustomer).then(res => {
                    //     // //console.log(res, 7878);

                    //     if (res && res.data && res.data.success) {
                    //         console.log(res, "response from customer out");
                    //     }

                    // }).catch(err => {
                    //     //console.log(err)
                    // })
                    this.props.setCallCenterCustomer(customer);
                    this.props.hoc.customAlert('Successfully submitted', true);
                    // this.props.navigate('/customer/place-order')
                }
            }).catch(e => {
                //console.log(e)
            })

        }


    }

    populateStates = (isoCode = null) => {
        if (isoCode) {
            CountryService.getStates(isoCode).then(data => {
                //console.log(data, "states")
                if (data.success) {
                    this.setState({ states: data.states, towns: [] }, async () => {
                        this.setState({ showTowns: false })
                        let _state = this.state.registration.address.state || null
                        console.log(_state, this.state.states, "jhgjhgjhg");
                        if (_state) {
                            let stateObj = null
                            for (let i = 0; i < this.state.states.length; i++) {
                                if (this.state.states[i].name === _state) {
                                    stateObj = this.state.states[i]
                                }
                            }
                            console.log(stateObj, _state, 1234545677);
                            console.log("stateObj found", stateObj)
                            // if (stateObj) {
                            setTimeout(() => {
                                this.populateTowns(stateObj.countryCode, stateObj.isoCode)
                            }, 500);
                            // }
                        }
                    })
                }
            })
        }
    }

    populateTowns = (countryCode = null, stateCode = null) => {
        console.log(countryCode, stateCode, "countryCode stateCode")
        if (countryCode && stateCode) {
            CountryService.getTowns(countryCode, stateCode).then(data => {
                console.log(data, "towns")
                // setTimeout(() => {
                if (data.success) {
                    this.setState({ towns: data.towns }, () => this.setState({ showTowns: true }))
                }
                // }, 2000);
            })
        }
    }

    handleOrderHistory = () => {

        const customer = this.props.CallCenterReducer.callcentercustomer;

        if (customer) {

            let details = {
                customer_id: customer._id
            }
            try {
                CustomerService.getOrders(details).then(res => {
                    if (res && res.data && res.data.success && res.data.data) {


                        if (res.data.data.order.length > 0) {
                            // this.props.navigate('/customer/track-order')
                            // this.props.saveAllOrder(res.data.data.order);
                            this.props.navigate('/orders')
                        } else {

                            this.props.hoc.customAlert('You dont have any order.', false);
                        }

                        console.log(res.data.data.order, "order details");

                    } else {

                        this.props.hoc.customAlert('You dont have any order.', false);
                    }

                })
            } catch (error) {
                console.log(error);
            }


        } else {

        }

        // this.props.navigate('/customer/orders');
    }

    handleConsentCheckbox = () => {

        const currentVal = !this.state.isChecked

        this.setState({ isChecked: currentVal });
        this.props.setConsentCheckbox(currentVal);

    }
    handleClickHome = () => {

        this.props.navigate('/callcenter/list')
    }

    setNumber = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        const reg = new RegExp('^[0-9]+$');
        if (!value || (reg.test(value) && value.length <= 10)) {


            const registration = { ...this.state.registration };
            registration[name] = value;
            this.setState({ registration: registration });
            // this.setState({ mobileno: val })
        }
    }


    render = () => {
        const { fileUploadError, color, registration, imagename, countries, states, towns, isLoading, showTowns } = this.state;
        const { name, address, age, email, gender, mobileno } = registration;
        const { country, addressLine1, addressLine2, pin, town, state } = address
        const { doctorName } = this.state;
        const { isChecked } = this.state;
        const isCheckedConsent = this.props.CustomerReducer.consentValue;
        console.log(isCheckedConsent, "isCheckedConsent", showTowns, town, state)
        //console.log(this.state, '>>>>>>>>>>>>>>>>>')
        return (
            <div>

                {/*myown-login-part-start-----*/}
                <section className="regstr-form">
                    <div className="container">
                        <CallCenterHeader />
                        <div className="mt-4">
                            <div className='row mt-20 mb-20'>
                                <div className='col-md-6'>
                                    <h2>Register Form</h2>
                                </div>
                                <div className='col-md-6'>
                                    <div className="btn-home flotright">
                                        <a href="javascript:void(0);" onClick={this.handleClickHome}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                                            Back
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <form className="mt-3 registration-form">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">Name <span className='requiredFld'> * </span></label>
                                    <input type="text" value={name} name="name" onChange={(event) => this.changeVal(event)} id className="form-control name-pt-ft" placeholder />
                                </div>
                                <div className="col-md-6 mb-3 for-apper-pt">
                                    <label htmlFor="disabledTextInput" className="form-label lvl-clr-hd">Age <span className='requiredFld'> * </span></label>
                                    <input type="number" value={age} onInput={(e) => e.target.value = e.target.value.slice(0, 2)} onChange={this.changeVal} name='age' className="form-control name-pt-ft" placeholder="Select age" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor className="form-label cls-gndr lvl-clr-hd">Gender <span className='requiredFld'> * </span></label>
                                    <select className="ml-feml-itm" value={gender} onChange={(event) => this.changeVal(event)} name="gender">
                                        <option value="" disabled selected hidden>Please Select</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="others">Others</option>
                                    </select>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="disabledTextInput" className="form-label lvl-clr-hd">Mobile Number <span className='requiredFld'> * </span>
                                    </label>
                                    <input type="text" value={mobileno} onChange={(event) => this.setNumber(event)} name="mobileno" id className="form-control name-pt-ft" placeholder />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">Email</label>
                                    <input type="text" value={email} name="email" onChange={(event) => this.changeVal(event)} id className="form-control name-pt-ft" placeholder />
                                </div>
                                {/* <div className="col-md-6 mb-3">
                                    <label htmlFor="disabledTextInput" className="form-label lvl-clr-hd">Prescribing Doctor <span className='requiredFld'> * </span></label>
                                    <input type="text" value={doctorName} disabled id className="form-control name-pt-ft" placeholder />
                                </div> */}
                            </div>
                            {/* <div className=" mt-4 mb-4">
                                <input
                                    type="file"
                                    ref={this.fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={this.handleFileChange}
                                />
                                <button type="button" className="upld-prscrbtn-pt" id onClick={this.handleButtonClick}>
                                    {this.state.imagename ? "Change Your Prescription" : "Upload Your Prescription"}
                                </button>
                                <p style={{ fontSize: 11, paddingTop: 10, textAlign: 'right', color: "#0a4f73", marginRight: 5 }}> Prescription needs to be uploaded in either jpeg, png and pdf format within a maximum limit of 10 MB </p>
                               
                                {isLoading ? <Loader /> : fileUploadError && <div style={{ color, textAlign: 'right', marginRight: 20 }}>{fileUploadError}</div>}
                                
                                {this.state.imagename != "" && <p>Selected file: {this.state.imagename}</p>}
                            </div> */}
                            <div className="reg-frm-dta align-items-center">
                                <div className="reg-text-ft"><h3>Product Delivery Address</h3></div>
                                {/* <div className="know-more-text mb-0">
                                    <a href={config.knowMoreLink} className="kow-more-link text-underline" target="_blank" rel="noopener noreferrer">Know more</a>
                                </div> */}
                            </div>
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">Address Line -1 <span className='requiredFld'> * </span></label>
                                    <input type="text" value={addressLine1} onChange={(event) => this.changeAddr(event)} name='addressLine1' id className="form-control name-pt-ft" placeholder />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-10 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">Address Line -2</label>
                                    <input type="text" value={addressLine2} onChange={(event) => this.changeAddr(event)} name='addressLine2' id className="form-control name-pt-ft" placeholder />
                                </div>
                                <div className="col-md-2 mb-3 for-apper-pt">
                                    {/* <div className="my-locatn">
                                        <button type className="use-lctn-part" onclick>
                                            <LocationIcon className="ionicon" />
                                            Use My Location
                                        </button>
                                    </div> */}
                                    <label htmlFor className="form-label lvl-clr-hd">Pin <span className='requiredFld'> * </span></label>
                                    <input type='number' onInput={(e) => e.target.value = e.target.value.slice(0, 6)} value={pin} onChange={(event) => this.changeAddr(event)} name="pin" id className="form-control name-pt-ft" placeholder />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="disabledTextInput" className="form-label lvl-clr-hd">Country <span className='requiredFld'> * </span></label>
                                    {
                                        countries.length &&
                                        <Dropdown
                                            items={countries}
                                            onSelect={(item) => {
                                                if (item) {
                                                    let _registration = this.state.registration
                                                    _registration.address["country"] = item.name
                                                    _registration.address["state"] = ""
                                                    _registration.address["town"] = ""
                                                    this.setState({ registration: _registration })
                                                    //console.log(item, "item");
                                                    this.populateStates(item.isoCode)
                                                }
                                            }}
                                            value={country}
                                            isDisabled={true}
                                        />
                                    }
                                    {/* <input type="text" readOnly value={"India"} onChange={(event) => this.changeAddr(event)} name="country" id className="form-control name-pt-ft" placeholder /> */}
                                    {/* <input type="text" value={country} onChange={(event) => this.changeAddr(event)} name="country" id className="form-control name-pt-ft" placeholder /> */}
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="disabledTextInput" className="form-label lvl-clr-hd">State <span className='requiredFld'> * </span></label>
                                    {
                                        states.length ?
                                            <Dropdown
                                                items={states}
                                                onSelect={(item) => {
                                                    if (item) {
                                                        let _registration = this.state.registration
                                                        _registration.address["state"] = item.name
                                                        _registration.address["town"] = ""
                                                        this.setState({ registration: _registration })
                                                        //console.log(item, "item");
                                                        this.populateTowns(item.countryCode, item.isoCode)
                                                    }
                                                }}
                                                value={state}
                                            /> :
                                            <Dropdown
                                                items={states}
                                                value={state}
                                            />
                                    }
                                    {/* <input type="text" value={state} onChange={(event) => this.changeAddr(event)} name="state" id className="form-control name-pt-ft" placeholder /> */}
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor className="form-label lvl-clr-hd">City/Town <span className='requiredFld'> * </span></label>
                                    {/* <p>{town}  {towns.length}   {JSON.stringify(towns)}</p> */}
                                    {
                                        towns.length ?
                                            <Dropdown
                                                items={towns}
                                                onSelect={(item) => {
                                                    if (item) {
                                                        let _registration = this.state.registration
                                                        _registration.address["town"] = item.name
                                                        this.setState({ registration: _registration })
                                                        //console.log(item, "item")
                                                    }
                                                }}
                                                value={town}
                                            /> :
                                            <Dropdown
                                                items={towns}
                                                value={town}
                                            />
                                    }
                                    {/* <input type="text" value={town} onChange={(event) => this.changeAddr(event)} name="town" id className="form-control name-pt-ft" placeholder /> */}
                                </div>
                            </div>
                            {/* <div className="row mt-4">
                                <div className='col-md-1 checkboxstyle'>
                                    <input type="checkbox" className='form-label' onChange={this.handleConsentCheckbox} checked={isCheckedConsent} />
                                </div>
                                <div className='col-md-10 consenttext' >
                                    <p>I consent to the sharing of my personal data for the purpose of purchasing medicinal products</p>
                                </div>
                            </div> */}
                            <div className="row mt-4">
                                <div className="end-bck-btn-pt">
                                    {/* <div className>
                                       
                                        <button type="button" className="bck-btn-crcl" onClick={this.handleOrderHistory}>
                                            Order History
                                        </button>
                                    </div> */}
                                    <div className>
                                        <button type="button" className="next-btn-crcl" id onClick={() => this.next()}>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </section>
                {/*myown-login-part-end-----------*/}
                <CustomerFooter />
            </div>
        )

    }

}

const mapDispatchToProps = (dispatch) => {
    return {
        // dispatching plain actions
        setCustomer: (customer) => dispatch(CustomerAction.setCustomer(customer)),
        setConsentCheckbox: (consentValue) => dispatch(CustomerAction.setConsentCheckbox(consentValue)),
        setCallCenterCustomer: (callcentercustomer) => dispatch(CallCenterAction.setCallCenterCustomer(callcentercustomer))
    }
}

const mapStateToProps = (state) => {
    return {
        // dispatching plain actions
        CustomerReducer: state.CustomerReducer,
        CommonReducer: state.CommonReducer,
        CallCenterReducer: state.CallCenterReducer
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Common(Registration)))